"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const layoutConfigs_1 = require("@configs/layoutConfigs");
const model_1 = require("@containers/common/model");
const Button_1 = __importDefault(require("@modules/Button"));
const react_redux_1 = require("react-redux");
const LineHeightButton = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const commonState = (0, react_redux_1.useSelector)((state) => (Object.assign({}, state.common)));
    const { globalStyle } = commonState;
    const isContentShrink = globalStyle.lineHeight === 'tight';
    const handleToggleLineHeight = () => {
        if (isContentShrink) {
            document.documentElement.style.setProperty('--custom-row-padding', layoutConfigs_1.layoutConfigs.LINE_HEIGHT.loose);
            dispatch((0, model_1.SET_GLOBAL_STYLE)(Object.assign(Object.assign({}, globalStyle), { lineHeight: 'loose' })));
        }
        if (!isContentShrink) {
            document.documentElement.style.setProperty('--custom-row-padding', layoutConfigs_1.layoutConfigs.LINE_HEIGHT.tight);
            dispatch((0, model_1.SET_GLOBAL_STYLE)(Object.assign(Object.assign({}, globalStyle), { lineHeight: 'tight' })));
        }
    };
    return ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ color: "secondary", onClick: handleToggleLineHeight }, { children: isContentShrink ? '寬鬆' : '緊縮' })));
};
exports.default = LineHeightButton;
